import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react"; // for tracking of errors
import { BrowserTracing } from "@sentry/tracing"; // for tracking of errors
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";

//BELOW (SENTRY) USED FOR TRACKING OF ERRORS:
Sentry.init({
  dsn: "https://47619cd32d4247eaae5ec65b48f2666c@o4504649422733312.ingest.sentry.io/4504649427058688",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const helmetContext = {}; //NOT SURE IF THIS IS NEEDED
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <HelmetProvider context={helmetContext}>
        <App />
      </HelmetProvider>
    </PersistGate>
  </Provider>
);
